import debounce from 'debounce';
import { Swiper, Pagination } from 'swiper';
import breakpoints from '../utils/breakpoints';
import {
    getColourOption,
    getOptionAfterColour,
    selectors,
} from '../utils/product';
import { getSizedUrl, createSourceSet } from '../utils/image';

Swiper.use([Pagination]);

const list = document.querySelector(selectors.images.list);
const template = document.querySelector(selectors.images.template).innerText;
const $body = document.querySelector('body');
const { desktop } = breakpoints;
const videoId = window.theme.product.videoId;
const widthMediaQuery = window.matchMedia(`(min-width: ${desktop}px)`);

const classes = {
    multiColumn: 'product-images--multi',
    overlayActive: 'overlay--active',
};

class ProductImages {
    constructor(element, images) {
        this.$el = element;
        this.images = images;
        this.sliderSettings = {
            slidesPerView: 1,
            spaceBetween: 15,
            observer: true,
            cssMode: true,
            observeParents: true,
            observeSlideChildren: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                hideOnClick: false,
            },
        };
        this.colour = getColourOption();
        this.imageVariant = getOptionAfterColour().value;
        this.initSliderBasedOnScreenWidth();
        this.applyMinHeight();
        window.onresize = debounce(this.applyMinHeight.bind(this), 50);
        this.registerEventListeners();
    }

    initSliderBasedOnScreenWidth() {
        if (!widthMediaQuery.matches) {
            this.swiper = new Swiper(this.$el, this.sliderSettings);
        }

        widthMediaQuery.addListener(mediaQuery => {
            if (mediaQuery.matches) {
                this.swiper.destroy();
            } else {
                this.swiper = new Swiper(this.$el, this.sliderSettings);
            }
        });
    }

    applyMinHeight() {
        const productImageEl = this.$el.querySelector(
            '[data-product-images-item]'
        );
        if (productImageEl) {
            const offset = productImageEl.offsetHeight;
            const el = this.$el.querySelector('[data-product-images-list]');
            el.style.minHeight = `${offset}px`;
        }
    }

    update(event) {
        const variantIndex = Number(event.target.closest('[data-index]').dataset.index);
        const colour = getColourOption();
        const imageVariant = getOptionAfterColour().value;
        let filteredImages = [];

        const onlyColourOption = this.images.filter(image => image.alt && image.alt.includes('Option:')).length === 0 ? true : false;

        if(onlyColourOption) {
            if(variantIndex > 0) {
                return;
            }
        } else {
            if(variantIndex > 1) {
                return;
            }
        }



        function findOptionInAlt(option,alt) {
            return alt
                .split('_')
                .filter(value => value.includes(option))
                .toString()
                .replace(`${option}`, '');
        }

        const originalImages = this.images;


        let filteredBySpecialVariant = originalImages.filter(
            image => findOptionInAlt('Option:',image.alt) === imageVariant
        );

        /**
         * If the filter returns no matches for the special varaint we reset the array back to the original images.
         */

        if(filteredBySpecialVariant.length === 0) {
            filteredBySpecialVariant = originalImages;
        };


        let filteredByColour = filteredBySpecialVariant.filter(
            image => findOptionInAlt('Colour:',image.alt) === colour
        );


        if(filteredByColour.length === 0) {
            filteredImages = filteredBySpecialVariant;

            if(filteredBySpecialVariant.length === 0) {
                filteredImages = originalImages;
            }

        } else {
            filteredImages = filteredByColour
        }

        list.innerHTML = filteredImages
            .map((image, index) => {
                const alt = image.alt.split('_')[0].replace('Description:', '')
                const srcset = createSourceSet(image.src, [
                    { dimensions: { width: 768 } },
                    { dimensions: { width: 900 } },
                    { dimensions: { width: 1024 } },
                    { dimensions: { width: 1600 } },
                ]);
                const length = filteredImages.length;

                if (index === 1 && videoId !== null) {
                    return `
                        <li class="product-images__item swiper-slide" data-product-video>
                            <div class="product-images__item__overlay"></div>
                            <iframe src="https://player.vimeo.com/video/${videoId}?api=1&background=1&loop=1" frameborder="0"></iframe>
                        </li>
                        ${
                            template
                            .replace(/<srcset>/gi, srcset)
                            .replace(/<image>/gi, getSizedUrl(image.src, 425))
                            .replace(/<formatted_alt>/gi, alt)
                        }
                    `
                }

                if (length <= 1 && videoId !== null) {
                    return `
                        ${
                            template
                            .replace(/<srcset>/gi, srcset)
                            .replace(/<image>/gi, getSizedUrl(image.src, 425))
                            .replace(/<formatted_alt>/gi, alt)
                        }
                        <li class="product-images__item swiper-slide" data-product-video>
                            <div class="product-images__item__overlay"></div>
                            <iframe src="https://player.vimeo.com/video/${videoId}?api=1&background=1&loop=1" frameborder="0"></iframe>
                        </li>
                    `
                }

                return template
                    .replace(/<srcset>/gi, srcset)
                    .replace(/<image>/gi, getSizedUrl(image.src, 768))
                    .replace(/<formatted_alt>/gi, alt);

            })
            .join('');

        list.classList.toggle(classes.multiColumn, filteredImages.length > 3);

        this.colour = colour;
        if (this.swiper) {
            this.swiper.updateSlides();
            this.swiper.slideTo(0);
        }

        this.registerEventListeners();
    }


    registerEventListeners() {
        this.$el
            .querySelectorAll('[data-product-images-item]')
            .forEach($item => {
                $item.addEventListener('click', () => {
                    if (widthMediaQuery.matches) {
                        $body.classList.toggle(classes.overlayActive);
                        $item.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center',
                        });
                    }
                });
            });

        this.$el
            .querySelector('[data-product-images-close]')
            .addEventListener('click', () => {
                if (widthMediaQuery.matches) {
                    $body.classList.remove(classes.overlayActive);
                }
            });
    }
}

export default ProductImages;
